import { client, request } from "./_base";

const endpoint = "clientsContractsGrades";

export const clientsContractsGrades = client(endpoint, (item) => ({
  ...item,
}));

export const clientscontractsGradesFull = (clientscontractid) => {
  return request(`${endpoint}/ext/full/${clientscontractid}`, {
    method: "GET",
  })
    .then(async (result) => {
      if (result.status == 500) {
        const resp = await result.json();
        throw resp;
      }
      return result.json();
    })
    .then(({ data }) => {
      return data;
    });
};
